<script setup>
import { inject, provide } from 'vue'
import emitter from '@/plugins/mittPlugin.js'
import InfoExtProfileDefaultItem
  from '@/components/Creator/Content/Info/Includes/InfoExtProfile/Includes/InfoExtProfileItems/Includes/InfoExtProfileDefaultItem.vue'
import InfoExtProfileZodiacItem
  from '@/components/Creator/Content/Info/Includes/InfoExtProfile/Includes/InfoExtProfileItems/Includes/InfoExtProfileZodiacItem.vue'
import InfoExtProfileBornInItem
  from '@/components/Creator/Content/Info/Includes/InfoExtProfile/Includes/InfoExtProfileItems/Includes/InfoExtProfileBornInItem.vue'
import InfoExtProfileMaritalStatusItem
  from '@/components/Creator/Content/Info/Includes/InfoExtProfile/Includes/InfoExtProfileItems/Includes/InfoExtProfileMaritalStatusItem.vue'

defineProps({
  items: {
    type: Object,
    required: true
  }
})

const creator = inject('creator')

const checkSubscription = (item) => {
  if (!item.bySubscription) {
    return false
  }

  return item.bySubscription && !creator.subscribed && item.value
}

provide('checkSubscription', checkSubscription)

function emit () {
  emitter.emit('open-subscribe-modal')
}
</script>

<template>
  <div class="grid gap-2 grid-cols-2">
    <div
      v-for="(item, key) in items"
      :key="item.title">
      <h5 class="text-sm font-bold mb-0.5">
        {{ item.title }}
      </h5>

      <div
        v-if="item.value"
        class="relative inline-block overflow-hidden rounded-md border border-white/40 w-full">
        <InfoExtProfileZodiacItem
          v-if="key === 'zodiacSign'"
          :item="item"/>

        <InfoExtProfileBornInItem
          v-else-if="key === 'bornIn'"
          :item="item"/>

        <InfoExtProfileMaritalStatusItem
          v-else-if="key === 'maritalStatus'"
          :item="item"/>

        <InfoExtProfileDefaultItem
          v-else
          :item="item"/>

        <div
          v-if="checkSubscription(item)"
          class="absolute top-0 bottom-0 left-0 right-0 m-auto flex items-center justify-center cursor-pointer"
          @click="emit">
          <div class="flex items-center gap-1.5 text-sm text-brand">
            <InlineSvg
              :src="require('@/assets/svg/design/lock-brand.svg')"
              class="w-3.5 text-gray-100"/>

            {{ $t('creator.profile.for_subscribers') }}
          </div>
        </div>
      </div>

      <router-link
        v-else
        :to="`/chat/${creator.userId}`"
        class="text-sm text-brand underline"
        type="button">
        {{ $t('creator.profile.ask_me') }}
      </router-link>
    </div>
  </div>
</template>